import ManualCallBroadcast from "@/components/calls/ManualCallBroadcast";
export default [
  {
    path: "/manualCallBroadCast",
    name: "ManualCallBroadcast",
    component: ManualCallBroadcast,
    meta: {
      requiresAuthentication: true
    }
  }
];
